const prefix = ''

export const emailsUrls = {
  'emails.list': `${prefix}/emails`,
  'emails.single': (emailId = ':emailId') => `${prefix}/emails/${emailId}`,
}
